import React from 'react';
import Tabs from 'components/layout/Tabs/Tabs';

export default function TodoTabs() {
  const tabs = [
    { name: 'All todos', href: '/todos' },
    { name: 'Create todo', href: '/todos/add' },
    { name: 'Tags', href: '/todos/tags' },
  ];

  return <Tabs tabs={tabs} />;
}
